import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import type { ObjPathProxy } from "ts-object-path";
import { MyPlannCzechResourcesDictionary } from "web_myplann/Infrastructure/Translations/CzechResourcesDictionary";
import { MyPlannEnglishResourcesDictionary } from "web_myplann/Infrastructure/Translations/EnglishResourcesDictionaty";
import type { MyPlannResourceDictionary } from "web_myplann/Infrastructure/Translations/ResourceDictionary";
import { Resources } from "web_myplann/Infrastructure/Translations/Resources";
import {
	DEFAULT_LANGUAGE,
	type Language,
} from "web_myplann/Utils/WebViewModel";

const LANGUAGE_LABELS: Record<
	Language,
	ObjPathProxy<MyPlannResourceDictionary, string>
> = {
	cs: Resources.Settings.LanguageOptions.Czech,
	en: Resources.Settings.LanguageOptions.English,
};

export const LANGUAGE_OPTIONS = (
	Object.keys(LANGUAGE_LABELS) as Language[]
).map((code) => ({ code, label: LANGUAGE_LABELS[code] }));

const isLanguage = (language: string): language is Language =>
	language in LANGUAGE_LABELS;

export const getLanguageLabel = () =>
	LANGUAGE_LABELS[isLanguage(i18n.language) ? i18n.language : DEFAULT_LANGUAGE];

export const initI18n = () => {
	if (i18n.isInitialized) {
		return;
	}
	i18n.use(initReactI18next).init({
		resources: {
			cs: { translation: MyPlannCzechResourcesDictionary },
			en: { translation: MyPlannEnglishResourcesDictionary },
		},
		lng: DEFAULT_LANGUAGE,
		fallbackLng: DEFAULT_LANGUAGE,
		interpolation: { escapeValue: false },
	});
};
